<template>
  <div class="h-full">
    <div v-if="suggested_lists.length">
      <div v-show="false" v-if="suggested_lists && !editing_disabled" class="flex justify-end p-2">
        <RecordActionsDropDown
          class="ml-auto"
          :object-type="suggested_lists[0].type"
          :page-reference="PAGE_REFERENCES.PROSPECTING_SUGGESTED"
          :selected-records="Array.from(selected_records)" />
      </div>

      <!-- LOADING COLORS -->

      <div class="bg-red-error" />
      <div class="bg-green-success" />
      <div class="bg-status-warning-yellow" />

      <div class="bg-red-error/10 border-red-error text-red-error" />
      <div class="bg-green-success/10 border-green-success text-green-success" />
      <div class="bg-status-warning-yellow/10 border-status-warning-yellow text-status-warning-yellow" />

      <div v-show="!suggested_lists.length" class="min-h-[400px] bg-light-screen-background dark:bg-dark-screen-background" />

      <div class="text-xl mb-3 font-medium">
        {{ label }}
      </div>

      <div v-for="(list, index) in suggested_lists" :key="list.id" class="px-2 pb-4">
        <div class="flex items-center">
          <input
            v-show="false"
            type="checkbox"
            :class="[`form-checkbox w-4  rounded h-4 dark:bg-dark-screen-background mr-6`]"
            @input="(e) => toggleSelectedAllRecord(list.records.results, e.target.checked)">
          <div>
            <div class="flex items-center text-light-black-text dark:text-white text-lg">
              {{ list.name }}
              <span
                :class="[
                  `ml-2 ${
                    list.records_count_change
                      ? list.records_count_change > 0
                        ? 'text-green-success'
                        : 'text-red-error'
                      : 'text-status-warning-yellow'
                  }  text-lg`
                ]">{{ list.records_count }}</span>

              <span
                v-if="list.records_count_change"
                :class="[
                  `ml-2 ${
                    list.records_count_change
                      ? list.records_count_change > 0
                        ? 'text-green-success'
                        : 'text-red-error'
                      : 'text-status-warning-yellow'
                  } ${
                    list.records_count_change
                      ? list.records_count_change > 0
                        ? 'bg-green-success/10'
                        : 'bg-red-error/10'
                      : 'bg-status-warning-yellow/10'
                  }  px-2 rounded-full flex items-center h-6 text-sm`
                ]"><ChevronUp
                :color="list.records_count_change < 0 ? '#F05B5B' : '#27C884'"
                :class="[`${list.records_count_change < 0 ? 'rotate-180' : ''} h-3 w-3 mr-1`]" />{{ list.records_count_change }}</span>
            </div>
            <div class="text-common-grey">
              {{ list.description }}
            </div>
          </div>
          <div class="flex ml-auto">
            <div
              v-if="$store.state.data.solid_metrics_suggested[list.id]?.filter((stat) => stat.name == `Actual value`).length"
              class="p-4">
              <div class="text-common-grey">
                {{ $t("Actual") }}
              </div>
              <div class="flex">
                <div class="text-light-black-text dark:text-white">
                  {{ list.solid_stats.total_actual_value ? `$${$utils.truncateNumber(list.solid_stats.total_actual_value)}` : "-" }}
                </div>

                <!-- <div :class="[`ml-2 text-green-success bg-green-success/10 px-2 rounded-full flex items-center h-6 text-sm`]"><ChevronUp color="#27C884" class="h-3 w-3 mr-1" />{{ list.values.actual.change }}</div> -->
              </div>
            </div>
            <div
              v-if="$store.state.data.solid_metrics_suggested[list.id]?.filter((stat) => stat.name == `Forecsted value`).length"
              class="p-4">
              <div class="text-common-grey">
                {{ $t("Forecast") }}
              </div>
              <div class="flex">
                <div class="text-light-black-text dark:text-white">
                  {{ list.solid_stats.total_forecasted_value ? `$${$utils.truncateNumber(list.solid_stats.total_forecasted_value)}` : "-" }}
                </div>
                <!-- <div :class="[`ml-2 text-green-success bg-green-success/10 px-2 rounded-full flex items-center h-6 text-sm`]"><ChevronUp color="#27C884" class="h-3 w-3 mr-1" />{{ stat.change?.change }}</div> -->
              </div>
            </div>
            <div v-for="stat in list.stats" :key="stat.id" class="p-4">
              <div class="text-common-grey">
                {{ stat.name }}
              </div>
              <div class="flex">
                <div class="text-light-black-text dark:text-white">
                  {{ stat.value ? `${$utils.humanizeMetricValue($utils.getMetricById(stat.id), stat.value)}` : "-" }}
                </div>
                <div v-if="stat.change" :class="[`ml-2 text-red-error bg-red-error/10 px-2 rounded-full flex items-center h-6 text-sm`]">
                  <ChevronUp color="#F05B5B" class="h-3 w-3 mr-1" />{{ stat.change }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :id="`item-${index}`" class="overflow-x-scroll flex no-scrollbar">
          <div v-if="!list.scrolled_to_start && list.scrolled_to_start !== undefined" class="absolute -ml-6 w-12 z-20">
            <div class="p-5 h-16 w-16 mt-[180%] rounded-full -ml-8" @click="(e) => scrollLeft(e, index)">
              <ChevronLeft
                class="animate animate-bounce-left rounded-full cursor-pointer ml-4 -mt-0 h-5 w-5 text-gray-600 dark:text-dark-body-text hover:text-common-grey"
                aria-hidden="true" />
            </div>
          </div>
          <div v-if="!list.scrolled_to_end && list.records.results.length > 4" class="absolute -right-2 h-[100%] z-10 w-12">
            <div class="p-5 h-16 w-16 mt-[180%] rounded-full ml-0" @click="(e) => scrollRight(e, index)">
              <ChevronRight
                class="animate animate-bounce-left right-12 -ml-4 cursor-pointer h-6 w-6 text-gray-600 dark:text-dark-body-text hover:text-common-grey"
                aria-hidden="true" />
            </div>
          </div>
          <div v-if="!list.records.results.length" class="text-common-grey ml-5 p-3">
            {{ $t("No records to display") }}
          </div>
          <div
            v-for="record in list.records.results"
            :key="record.id"
            else
            :class="[
              ` overflow-visible relative max-w-[20vw] min-w-[20vw] mx-2  bg-white dark:bg-dark-box-background p-2 rounded-lg mb-4 `
            ]">
            <div class="border-b border-[#B3CAD6] dark:border-dark-divider-border p-3">
              <div class="flex items-center">
                <div :style="{ backgroundColor: record.color }" class="w-3 h-3 rounded-full" />
                <div
                  class="cursor-pointer text-grey-light-body dark:text-dark-body-text ml-2 text-lg"
                  @click="editing_disabled ? null : openRecordDetailsPage(list, record)">
                  {{ Record.from(record).name }}
                </div>
                <!-- <HideIcon color="#899399" class="h-4 w-4 mr-1 ml-3 cursor-pointer" /> -->

                <input
                  v-if="!editing_disabled"
                  v-show="false"
                  :disabled="editing_disabled"
                  :checked="[...selected_records]?.filter((r) => r == record.id).length"
                  :style="{ color: record.color }"
                  type="checkbox"
                  :class="[`form-checkbox w-4 rounded h-4 dark:bg-dark-box-background ml-auto`]"
                  @click="(e) => (editing_disabled ? null : handleCheckClick(e, record))">
              </div>
            </div>

            <div class="mt-3 p-2">
              <div
                v-if="$store.state.data.solid_metrics_suggested[list.id]?.filter((stat) => stat.name == `Actual value`).length"
                class="flex mb-2">
                <div class="text-common-grey">
                  {{ $t("Actual") }}
                </div>
                <div class="text-grey-light-body dark:text-dark-body-text ml-auto">
                  {{ $utils.truncateNumber(record.base_value) ? `$${$utils.truncateNumber(record.base_value)}` : `-` }}
                </div>
              </div>
              <div
                v-if="$store.state.data.solid_metrics_suggested[list.id]?.filter((stat) => stat.name == `Forecasted value`).length"
                class="flex mb-2">
                <div class="text-common-grey">
                  {{ $t("Forecasted") }}
                </div>
                <div class="text-grey-light-body dark:text-dark-body-text ml-auto">
                  {{ $utils.truncateNumber(record.forecasted_value) ? `$${$utils.truncateNumber(record.forecasted_value)}` : `-` }}
                </div>
              </div>
              <div v-for="metric_id in list.displayed_metrics_stats" :key="metric_id" class="flex mb-2">
                <div class="text-common-grey">
                  {{ $utils.getMetricById(metric_id).name }}
                </div>
                <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
                  {{
                    record.values[$utils.getMetricById(metric_id).reference_name]
                      ? $utils.humanizeMetricValue(
                        $utils.getMetricById(metric_id),
                        record.values[$utils.getMetricById(metric_id).reference_name]
                      )
                      : " - "
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="suggested_lists.length == 0 && is_loading"
      class="bg-white dark:bg-dark-box-background flex justify-center h-full overflow-hidden rounded-lg p-5">
      <div class="flex justify-center flex-col">
        <h3 class="capitalize mt-2 text-2xl font-normal text-gray-500 relative">
          {{ $t("Loading suggested lists") }} <LoadingSpinner class="" />
        </h3>
      </div>
    </div>
    <div v-else class="bg-white dark:bg-dark-box-background flex justify-center h-full overflow-hidden rounded-lg p-5">
      <div class="flex justify-center items-center flex-col">
        <Info class="h-20 w-20 text-blue" aria-hidden="true" />
        <h3 class="mt-2 text-xl font-normal text-black dark:text-white">
          {{ $t("No Suggested lists found") }}
        </h3>
        <p class="mt-2 text-md font-normal text-gray-500">
          {{
            $t("You don't have any saved Suggested Lists right now. You can easily add any customer or contact to an Suggested settings.")
          }}
        </p>
        <div class="primary-btn w-fit m-2" @click="$router.push('/organization/?tab=suggested')">
          <Settings class="w-7 h-7 ml-1" />
          <div class="pl-1">
            <span>{{ $t("Setup Suggested Lists") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataService from "@/services/data.service"
import RecordActionsDropDown from "@/components/shared/RecordActionsDropDown.vue"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import { ChevronUp, ChevronRight, ChevronLeft, Info, Settings } from "lucide-vue-next"
import { PAGE_REFERENCES } from "@/store/constants/references"
import { utils } from "@/store/helpers"
import { Record } from "@/models/record"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    LoadingSpinner,
    Info,
    RecordActionsDropDown,
    Settings,
    ChevronUp,
    ChevronLeft,
    ChevronRight
  },
  inject: ["canUserEditLayout"],
  props: {
    dataSource: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  emits: ["selectedRecords"],

  data() {
    return {
      Record,
      is_loading: false,
      PAGE_REFERENCES,
      selected_records: new Set(),
      suggested_lists: []
    }
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    }
  },

  created() {
    this.register_listeners()

    this.getSuggestedList()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.REMOVE_SUGGESTED_LIST_IN_SUGGESTED_LIST_COMPONENT, (list_id) => {
        utils.removeItem(this.suggested_lists, list_id)
      })
      this.$emitter.on(ALL_EMITTERS.SUGGESTED_LIST_CREATED_IN_SUGGESTED_LISTS_COMPONENT, (list) => {
        dataService
          .getOneMatrixCompanies(list.id, {
            type: "suggested",
            include_rollup_metrics: true
          })
          .then((res) => {
            this.suggested_lists.push(res.data.data)
          })
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.REMOVE_SUGGESTED_LIST_IN_SUGGESTED_LIST_COMPONENT)
      this.$emitter.off(ALL_EMITTERS.SUGGESTED_LIST_CREATED_IN_SUGGESTED_LISTS_COMPONENT)
    },
    openRecordDetailsPage(list, record) {
      if (record.type == "company") {
        this.$router.push(`/company/${record.id}`)
      } else {
        this.$router.push(`/company/${record.parent}/${list.type}/${record.id}`)
      }
    },
    handleCheckClick(e, record) {
      this.toggleSelectedRecord(record, e.target.checked)
    },

    scrollLeft(e, index) {
      let content = document.querySelector(`#item-${index}`)
      content.scrollLeft -= 150
    },

    scrollRight(e, index) {
      let content = document.querySelector(`#item-${index}`)
      content.scrollLeft += 150
    },

    getSuggestedList() {
      this.is_loading = true
      if (!this.dataSource) {
        dataService.getMatrixCompanies({ type: "suggested", include_rollup_metrics: false }).then((result) => {
          result.data.data.forEach((list) => {
            this.suggested_lists.push(list)
          })
          this.is_loading = false
        })
      } else {
        dataService
          .getOneMatrixCompanies(this.dataSource, {
            type: "suggested",
            include_rollup_metrics: false
          })
          .then((result) => {
            let list = result.data.data
            this.suggested_lists = []
            if (!list.is_removed) {
              list["allChecked"] = false
              list.records.results.map((x) => {
                x["checked"] = false
              })
              this.suggested_lists.push(list)
            }
            this.is_loading = false
          })
          .catch(() => {
            this.is_loading = false
          })
      }
    },

    toggleSelectedAllRecord(records, isChecked) {
      if (isChecked) {
        this.selected_records = new Set(records.map((x) => x.id))
      } else {
        this.selected_records = new Set()
      }

      this.$emit("selectedRecords", Array.from(this.selected_records))
    },
    toggleSelectedRecord(record, isChecked) {
      if (isChecked) {
        this.selected_records.add(record.id)
      } else {
        this.selected_records.delete(record.id)
      }

      this.$emit("selectedRecords", Array.from(this.selected_records))
    }
  }
}
</script>

<style scoped>
[data-tooltip]:before {
  position: absolute;
  content: attr(data-tooltip);
  opacity: 0;
  transition: all 0.15s ease;
  padding: 8px 16px;
  color: rgb(0, 0, 0);
  border-radius: 10px;
  box-shadow: 2px 2px 1px silver;
}

[data-tooltip]:hover:before {
  opacity: 1;
  background: rgb(255, 255, 255);
  margin-left: 124px;
}

.header-background {
  background: #07455d;
}
</style>
